const findLast = require('array.prototype.findlast');

if (!Array.prototype.findLast) {
  delete Array.prototype.findLast;
  findLast.shim();
}
